import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "37",
  fill: "none",
  viewBox: "0 0 35 34"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#363B59",
  "fill-rule": "evenodd",
  stroke: "#363B59",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6.656 14.182c-1.327 0-2.42 1.026-2.42 2.273V31c0 1.247 1.093 2.273 2.42 2.273h19.355c1.327 0 2.42-1.026 2.42-2.273V16.455c0-1.247-1.093-2.273-2.42-2.273zm-5.322 2.273c0-2.753 2.391-5 5.322-5h19.355c2.93 0 5.323 2.247 5.323 5V31c0 2.753-2.392 5-5.323 5H6.656c-2.93 0-5.322-2.247-5.322-5z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#363B59",
  "fill-rule": "evenodd",
  stroke: "#363B59",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M16.34 21.454c.802 0 1.451.61 1.451 1.364v4.727c0 .753-.65 1.364-1.451 1.364-.802 0-1.452-.611-1.452-1.364v-4.727c0-.753.65-1.364 1.452-1.364",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#363B59",
  "fill-rule": "evenodd",
  stroke: "#363B59",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M16.2 21.415s-.01.01-.01.036.01.035.01.036.01.01.038.01.038-.01.038-.01.01-.01.01-.036-.01-.035-.01-.036-.01-.01-.038-.01-.037.01-.038.01m-2.053-1.928c1.148-1.078 3.035-1.078 4.182 0a2.67 2.67 0 0 1 0 3.928c-1.147 1.078-3.034 1.078-4.182 0a2.67 2.67 0 0 1 0-3.928M16.332 2.818c-3.723 0-6.774 2.866-6.774 6.364v3.636c0 .502-.433.91-.968.91s-.967-.408-.967-.91V9.182C7.623 4.68 11.54 1 16.333 1c4.792 0 8.709 3.68 8.709 8.182v3.636c0 .502-.433.91-.968.91s-.968-.408-.968-.91V9.182c0-3.498-3.05-6.364-6.774-6.364",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }